var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{style:(_vm.styleEx),attrs:{"src":_vm.getAbsPath(_vm.spinnerSrc),"width":_vm.width,"height":_vm.width,"alt":_vm.alt}})
}
var staticRenderFns = []

export { render, staticRenderFns }